function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useCallback, useState } from 'react';
import { useReactRedux } from '@applyboard/ab-common';
import { Checkbox, FormControlLabel } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import useInitialProps from "../../../../hooks/useInitialProps";
import useReduxDispatcher from "../../../../hooks/useReduxDispatcher";
import ActualStartDatesModal from "../../../../components/Modals/ActualStartDatesModal";
import { applicationSetDatesAction, setIsInitialActualStartDatesAction } from "../../../../store/actions/application";
var parseErrors = function parseErrors(msg) {
  if (!msg || !msg.errors) {
    return {};
  }
  if (msg.errors.length === 0) {
    return {};
  }
  /*
    Convert error message from
    {"errors": [{"program_actual_start_date":["Program actual start date is required"]}, {"esl_actual_start_date":["ESL actual start date is required"]}]}
    to
    { [key: string]: string }
  */

  var retVal = {};
  Object.keys(msg.errors).forEach(function (key) {
    retVal[key] = msg.errors[key].join(',');
  });
  return retVal;
};
var intakeSelector = function intakeSelector(state) {
  var _state$application, _state$application$ap;
  return (state === null || state === void 0 ? void 0 : (_state$application = state.application) === null || _state$application === void 0 ? void 0 : (_state$application$ap = _state$application.application) === null || _state$application$ap === void 0 ? void 0 : _state$application$ap.intake) || null;
};
var eslIntakeSelector = function eslIntakeSelector(state) {
  var _state$application2, _state$application2$a;
  return (state === null || state === void 0 ? void 0 : (_state$application2 = state.application) === null || _state$application2 === void 0 ? void 0 : (_state$application2$a = _state$application2.application) === null || _state$application2$a === void 0 ? void 0 : _state$application2$a.intake_esl) || null;
};
var ReadyForVisaCheckbox = function ReadyForVisaCheckbox(_ref) {
  var _application$status;
  var application = _ref.application,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    tooltip = _ref.tooltip,
    reloadAggregatedData = _ref.reloadAggregatedData;
  var value = !!(application !== null && application !== void 0 && (_application$status = application.status) !== null && _application$status !== void 0 && _application$status.ready_for_visa);
  var _ref2 = useInitialProps(),
    userRole = _ref2.role;
  var _useEventTracker = useEventTracker({
      data: {
        userRole: userRole
      }
    }),
    trackReadyForVisaChangeEvent = _useEventTracker.trackEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var setDates = useReduxDispatcher(applicationSetDatesAction);
  var setInitialDates = useReduxDispatcher(setIsInitialActualStartDatesAction);
  var _useReactRedux = useReactRedux(function (state) {
      return {
        date: intakeSelector(state),
        eslDate: eslIntakeSelector(state)
      };
    }),
    date = _useReactRedux.date,
    eslDate = _useReactRedux.eslDate;
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var closeModal = useCallback(function () {
    setShowModal(false);
  }, [setShowModal]);
  var handleOnChange = useCallback(function (event) {
    var checkedValue = event.target.checked;
    if (disabled) {
      return;
    }
    if (checkedValue !== true) {
      setDates(null, date || null, null, eslDate || null, null, null, null, null);
      setInitialDates(true);
      trackReadyForVisaChangeEvent({
        event: 'Single Application - Status - Unchecked Ready For Visa Checkbox'
      });
      return onChange(event).then(function (response) {
        reloadAggregatedData();
        return response;
      });
    }
    setShowModal(true);
  }, [disabled, setShowModal]);
  var handleModalSuccess = useCallback(function (actState) {
    if (!actState || !actState.program_actual_start_date) {
      setErrors({
        program_actual_start_date: 'ACD Start Date cannot be empty'
      });
      return;
    }
    setErrors({});
    onChange(true, actState).then(function (response) {
      if (response && !response.errors) {
        setShowModal(false);
        trackReadyForVisaChangeEvent({
          event: 'Single Application - Status - Clicked Confirm to Update Status to Ready for Visa',
          data: {
            acdIntakeChanged: date !== actState.intake_date,
            eslIntakeChanged: eslDate !== actState.esl_intake_date
          }
        });
        setDates(null, actState.intake_date, null, actState.esl_intake_date, actState.esl_actual_start_date, actState.program_actual_start_date, actState.esl_alternate_actual_start_date, actState.program_alternate_actual_start_date);
        setInitialDates(true);
        reloadAggregatedData();
      }
    })["catch"](function (err) {
      var _err$response, _err$response$data;
      if (err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.errors) {
        setErrors(parseErrors(err.response.data));
      }
    });
  }, [onChange]);
  var modalIsVisible = value === false && showModal;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: value,
      onChange: handleOnChange,
      name: "ready_for_visa",
      color: "primary",
      disabled: disabled
    }),
    "data-tip": tooltip,
    label: "Ready for Visa",
    labelPlacement: "start",
    m: 0
  }), modalIsVisible && /*#__PURE__*/React.createElement(ActualStartDatesModal, {
    application: application,
    intake: date,
    eslIntake: eslDate,
    errors: errors,
    onClose: closeModal,
    onSubmit: handleModalSuccess
  }));
};
export default ReadyForVisaCheckbox;